<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
  <span class="icon"><i class="fas fa-truck" aria-hidden="true"></i></span>{{ "CarSequenceMaintenance.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [(selected)]="isSearchFormOpen"
      >
        <!-------------------------------------- Query Form ---------------------------------------------->
        <form [formGroup]="searchFormGroup" (ngSubmit)="searchBtnClick()">
          <div class="p-fluid formgrid grid">
            <div class="col-6 field">
              <h3>{{ 'CarSequenceMaintenance.Form.Time.Header' | translate }}</h3>
              <div class="formgrid grid">

                <!-------------------------------------- Start Time Slot ---------------------------------------------->
                <div class="col field">
                  <label for="starttime">{{ 'CarSequenceMaintenance.Form.Time.StartTime' | translate }}</label>
                  <p-calendar
                    #startTime
                    inputId="starttime"
                    formControlName="startTime"
                    hourFormat="24"
                    [timeOnly]="true"
                    [showIcon]="true"
                    (onFocus)="focusTimePicker($event, startTime)"
                    (onInput)="checkTimeInput($event, startTime)"
                    icon="pi pi-clock"
                    placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.Time.SelectAStartTime' | translate }}"
                  >
                  </p-calendar>
                </div>

                <!-------------------------------------- End Time Slot ---------------------------------------------->
                <div class="col field">
                  <label for="endtime">{{ 'CarSequenceMaintenance.Form.Time.EndTime' | translate }}</label>
                  <p-calendar
                    #endTime
                    inputId="endtime"
                    formControlName="endTime"
                    hourFormat="24"
                    [timeOnly]="true"
                    [showIcon]="true"
                    (onFocus)="focusTimePicker($event, endTime)"
                    (onInput)="checkTimeInput($event, endTime)"
                    icon="pi pi-clock"
                    placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.Time.SelectAnEndTime' | translate }}"
                  >
                  </p-calendar>
                </div>
              </div>
            </div>

            <div class="col-6 field">
              <h3>{{ 'CarSequenceMaintenance.Form.Departure.Header' | translate }}</h3>
              <div class="formgrid grid">

                 <!-------------------------------------- Departure Day Slot ---------------------------------------------->
                <div class="col field">
                  <label for="departureday">{{ 'CarSequenceMaintenance.Form.Departure.DepartureDay' | translate }}</label>
                  <p-dropdown
                  inputId="departureday"
                  [options]="departureDayOptions"
                  [showClear]="true"
                  formControlName="departureDay"
                  placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.Departure.SelectADepartureDay' | translate }}"
                  >
                  </p-dropdown>
                </div>

                 <!-------------------------------------- Departure Time Slot ---------------------------------------------->
                <div class="col field">
                  <label for="departuretime">{{ 'CarSequenceMaintenance.Form.Departure.DepartureTime' | translate }}</label>
                  <p-calendar
                  #departureTime
                  inputId="departuretime"
                  formControlName="departureTime"
                  hourFormat="24"
                  [timeOnly]="true"
                  [showIcon]="true"
                  (onFocus)="focusTimePicker($event, departureTime)"
                  (onInput)="checkTimeInput($event, departureTime)"
                  icon="pi pi-clock"
                  placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.Departure.SelectADepartureTime' | translate }}"
                  >
                  </p-calendar>
                </div>
              </div>
            </div>

             <!-------------------------------------- Delivery Category Slot ---------------------------------------------->
            <div class="col-4 field">
              <label for="deliverycategory">{{ 'CarSequenceMaintenance.Form.DeliveryCategory' | translate }}</label>
              <p-dropdown
                inputId="deliverycategory"
                [options]="deliveryCategoryOptions"
                [showClear]="true"
                formControlName="deliveryCategory"
                placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectADeliveryCategory' | translate }}"
              >
              </p-dropdown>
            </div>

            <!-------------------------------------- Pickup Location Type Slot ---------------------------------------------->
            <div class="col-4 field">
              <label for="pickuplocationtype">{{ 'CarSequenceMaintenance.Form.PickupLocationType' | translate }}</label>
              <p-dropdown
                inputId="pickuplocationtype"
                [options]="pickupLocationTypeOptions"
                [showClear]="true"
                formControlName="pickupLocationType"
                placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectAPickupLocationType' | translate }}"
              >
              </p-dropdown>
            </div>

             <!-------------------------------------- Assignment District ID Slot ---------------------------------------------->
            <div class="col-4 field">
              <label for="assignmentdistrictid">{{ 'CarSequenceMaintenance.Form.AssignmentDistrictId' | translate }}</label>
              <p-multiSelect
                inputId="assignmentdistrictid"
                [options]="assignmentDistrictIdOptions"
                [virtualScroll]="true"
                [itemSize]="40"
                optionsLabel="label"
                optionValue="value"
                display="chip"
                formControlName="assignmentDistrictId"
                placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectOneOrMoreAssignmentDistrictId' | translate }}"
              >
              </p-multiSelect>
            </div>

             <!-------------------------------------- ETD Slot ---------------------------------------------->
            <div class="col-4 field">
              <label for="etd">{{ 'CarSequenceMaintenance.Form.ETD' | translate }}</label>
              <p-dropdown
                inputId="etd"
                [options]="etdOptions"
                [showClear]="true"
                formControlName="etd"
                placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectANETD' | translate }}"
              >
              </p-dropdown>
            </div>

            <!-------------------------------------- Week Day Slot ---------------------------------------------->
            <div class="col-4 field">
              <label for="weekday">{{ 'CarSequenceMaintenance.Form.WeekDay' | translate }}</label>
              <p-multiSelect
                inputId="weekday"
                optionLabel="label"
                optionValue="value"
                [options]="weekDayOptions"
                [filter]="false"
                display="chip"
                formControlName="weekDay"
                placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectOneOrMoreWeekDay' | translate }}"
              >
              </p-multiSelect>
            </div>

            <!-------------------------------------- Is Work Day Slot ---------------------------------------------->
            <div class="col-4 field">
              <label for="isworkday">{{ 'CarSequenceMaintenance.Form.IsWorkDay' | translate }}</label>
              <p-dropdown
                inputId="isworkday"
                [options]="isWorkDayOptions"
                [showClear]="true"
                formControlName="isWorkDay"
                placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectIsWorkDayOrNot' | translate }}"
              >
              </p-dropdown>
            </div>

          </div>
          <div>
            <button pButton label="{{ 'Common.Button.Search' | translate }}" type="submit"></button>
            <button
              pButton
              label="{{ 'Common.Button.Reset' | translate }}"
              type="reset"
              class="p-button-secondary ml-2"
            ></button>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <!-------------------------------------- Table ---------------------------------------------->
    <p-table
      #table
      [columns]="selectedColumns"
      [value]="tableData"
      [loading]="isLoading"
      [reorderableColumns]="true"
      [resizableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"
      scrollDirection="both"

      [(selection)]="selectedRow"
      selectionMode="single"

      [lazy]="true"
      (onPage)="onTablePageChanging($event)"
      (onSort)="onTableSorting($event)"
      [resetPageOnSort]="false"

      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      [rows]="this.pageInfo.pageSize"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="this.pageInfo.totalRecords"

      class="editTable"
      dataKey="dataKey"
      editMode="row"
      styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped mt-2 white-space: nowrap;"
      [tableStyle]="{'min-width': '50rem'}"
      columnResizeMode="expand"
      >

      <ng-template pTemplate="caption">
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="table">
        </laas-table-column-toggle>
        <button
          pButton
          label="{{ 'Common.Button.Add' | translate }}"
          icon="fa fa-plus"
          [disabled]="!isInEditMode"
          (click)="addNewRow()"
          class="p-button-success p-button-raised ml-2">
        </button>
        <button
          pButton
          label="{{ 'Common.Button.Delete' | translate }}"
          icon="fas fa-trash-alt"
          [disabled]="!isInEditMode || tableData.length <= 0"
          (click)="deleteSelectedRow()"
          class="p-button-danger p-button-raised ml-2">
        </button>
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Save' | translate}}"
          icon="fas fa-save"
          [disabled]="!isInEditMode"
          (click)="saveChanges()"
          class="p-button-raised ml-2"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'CarSequenceMaintenance.Button.Restore' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!isInEditMode"
          (click)="restoreTableData()"
          class="p-button-secondary p-button-raised ml-2"
        ></button>
        <button
          pButton
          type="button"
          label="{{ isInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          icon="fas fa-pen"
          (click)="switchEditMode()"
          class="p-button-warning p-button-raised ml-2"
          style="color: white"
        ></button>
      </ng-template>


      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            *ngFor="let col of columns"
            scope="col"
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            pResizableColumn
            pReorderableColumn>
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-rowData
        let-columns="columns">

        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- Delivery Category Column ---------------------------------------------->
            <td *ngSwitchCase="'deliveryCategory'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown
                    [options]="deliveryCategoryOptions"
                    [(ngModel)]="rowData[col.field]"
                    [showClear]="true"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectADeliveryCategory' | translate }}">
                  </p-dropdown>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'CarSequenceMaintenance.Table.FieldRequired.DeliveryCategoryRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Start Time Column ---------------------------------------------->
            <td *ngSwitchCase="'startTime'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-calendar
                  #tableStartTime
                  [(ngModel)]="rowData[col.field]"
                  [timeOnly]="true"
                  [showIcon]="true"
                  (onFocus)="focusTimePicker($event, tableStartTime)"
                  (onInput)="checkTimeInput($event, tableStartTime)"
                  hourFormat="24"
                  icon="pi pi-clock"
                  appendTo="body"
                  class="p-fluid"
                  placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.Time.SelectAStartTime' | translate }}"
                  [style]="{'min-width':'10rem'}"
                  >
                  </p-calendar>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'CarSequenceMaintenance.Table.FieldRequired.StartTimeRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text" *ngIf="rowData[col.field] else nullStartTime">

                    <!-------------------- If hour or minute < 0, add 0 prefix e.g. 8:01 a.m. -> 0801 ---------------------------------------------->
                    <span><ng-container *ngIf="rowData[col.field].getHours() < 10">0</ng-container>{{rowData[col.field].getHours()}}</span>
                    <span><ng-container *ngIf="rowData[col.field].getMinutes() < 10">0</ng-container>{{rowData[col.field].getMinutes()}}</span>

                  </div>
                  <ng-template #nullStartTime>
                    <div class="overflow-text">
                      {{ null | replaceNullWith:'-'}}
                    </div>
                  </ng-template>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- End Time Column ---------------------------------------------->
            <td *ngSwitchCase="'endTime'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-calendar
                  #tableEndTime
                  [(ngModel)]="rowData[col.field]"
                  [timeOnly]="true"
                  [showIcon]="true"
                  (onFocus)="focusTimePicker($event, tableEndTime)"
                  (onInput)="checkTimeInput($event, tableEndTime)"
                  hourFormat="24"
                  icon="pi pi-clock"
                  appendTo="body"
                  class="p-fluid"
                  placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.Time.SelectAnEndTime' | translate }}"
                  [style]="{'min-width':'10rem'}"
                  >
                  </p-calendar>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'CarSequenceMaintenance.Table.FieldRequired.EndTimeRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text" *ngIf="rowData[col.field] else nullendtime">

                    <!-------------------- If hour or minute < 0, add 0 prefix e.g. 8:01 a.m. -> 0801 ---------------------------------------------->
                    <span><ng-container *ngIf="rowData[col.field].getHours() < 10">0</ng-container>{{rowData[col.field].getHours()}}</span>
                    <span><ng-container *ngIf="rowData[col.field].getMinutes() < 10">0</ng-container>{{rowData[col.field].getMinutes()}}</span>

                  </div>
                  <ng-template #nullendtime>
                    <div class="overflow-text">
                      {{ null | replaceNullWith:'-'}}
                    </div>
                  </ng-template>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Departure Column ---------------------------------------------->
            <td *ngSwitchCase="'departure'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <div class="p-fluid">

                    <!-------------------------------------- Departure Day Part ---------------------------------------------->
                    <div class="field">
                      <p-dropdown
                        [options]="departureDayOptions"
                        [(ngModel)]="rowData['departureDay']"
                        [showClear]="true"
                        appendTo="body"
                        placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.Departure.SelectADepartureDay' | translate }}"
                        >
                      </p-dropdown>
                    </div>

                    <!-------------------------------------- Departure Time Part ---------------------------------------------->
                    <div class="field">
                      <p-calendar
                        #tableDepartureTime
                        [(ngModel)]="rowData['departureTime']"
                        [timeOnly]="true"
                        [showIcon]="true"
                        (onFocus)="focusTimePicker($event, tableDepartureTime)"
                        (onInput)="checkTimeInput($event, tableDepartureTime)"
                        hourFormat="24"
                        icon="pi pi-clock"
                        appendTo="body"
                        placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.Departure.SelectADepartureTime' | translate }}"
                        >
                      </p-calendar>
                      <small *ngIf="!rowData['departureTime']" class="p-invalid">
                        {{ 'CarSequenceMaintenance.Table.FieldRequired.DepartureTimeRequired' | translate }}
                      </small>
                    </div>

                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    <span>{{rowData['departureDay']}}</span>
                    <ng-template [ngIf]="rowData['departureTime']">

                      <!-------------------- If hour or minute < 0, add 0 prefix e.g. 8:01 a.m. -> 0801 ---------------------------------------------->
                      <span><ng-container *ngIf="rowData['departureTime'].getHours() < 10">0</ng-container>{{rowData['departureTime'].getHours()}}</span>
                      <span><ng-container *ngIf="rowData['departureTime'].getMinutes() < 10">0</ng-container>{{rowData['departureTime'].getMinutes()}}</span>

                    </ng-template>
                    <ng-template [ngIf]="!rowData['departureDay'] && !rowData['departureTime']">
                      {{ null | replaceNullWith:'-'}}
                    </ng-template>
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- ETD Column ---------------------------------------------->
            <td *ngSwitchCase="'etd'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown
                    [options]="etdOptions"
                    [(ngModel)]="rowData[col.field]"
                    [showClear]="true"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectANETD' | translate }}">
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Assignment District ID Column ---------------------------------------------->
            <td *ngSwitchCase="'assignmentDistrictId'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-multiSelect
                    [options]="assignmentDistrictIdOptions"
                    [(ngModel)]="rowData[col.field]"
                    [virtualScroll]="true"
                    [itemSize]="40"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectOneOrMoreAssignmentDistrictId' | translate }}"
                    [style]="{'width':'18rem'}"
                  >
                  </p-multiSelect>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Pickup Location Type Column ---------------------------------------------->
            <td *ngSwitchCase="'pickupLocationType'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown
                    [options]="pickupLocationTypeOptions"
                    [(ngModel)]="rowData[col.field]"
                    [showClear]="true"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectAPickupLocationType' | translate }}">
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Week Day Column ---------------------------------------------->
            <td *ngSwitchCase="'weekDay'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-multiSelect
                    [options]="weekDayOptions"
                    [(ngModel)]="rowData[col.field]"
                    [filter]="false"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectOneOrMoreWeekDay' | translate }}"
                    [style]="{'width':'18rem'}"
                  >
                  </p-multiSelect>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Is Work Day Column ---------------------------------------------->
            <td *ngSwitchCase="'isWorkDay'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown
                    [options]="isWorkDayOptions"
                    [(ngModel)]="rowData[col.field]"
                    [showClear]="true"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'CarSequenceMaintenance.Placeholder.Form.SelectIsWorkDayOrNot' | translate }}">
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <td *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
